import React from "react";
import { useSiteConfig } from "../../context/site-configs-context";
import "./errorPage.scss";

type ErrorPageProps = {
  code?: number | string;
  message?: string;
  description?: string;
  showRefresh?: boolean;
  onRefresh?: () => void;
};


const ErrorPage: React.FC<ErrorPageProps> = ({
    code = 500,
    message = "Something went wrong",
    description = "An unexpected error occurred. Please try again.",
    showRefresh = false,
    onRefresh,
    
}) => {
  const { logo } = useSiteConfig();
  return (
    <div className="error-page">
      <div className="error-card">
        <img src={logo} width={250} alt="logo" />
        <div className="error-code">{code}</div>
        <h1 className="error-message">{message}</h1>
        <p className="error-description">{description}</p>

        <div className="error-actions">
          {showRefresh && (
            <button
              className="error-btn primary"
              onClick={onRefresh || (() => window.location.reload())}
            >
              Refresh
            </button>
          )}

          <button
            className="error-btn"
            onClick={() => (window.location.href = "/")}
          >
            Go Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;